import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-dados-curriculo',
    templateUrl: './dados-curriculo.component.html',
    styleUrls: ['./dados-curriculo.component.scss'],
    standalone: false
})
export class DadosCurriculoComponent implements OnInit {

  @Input() dados: any;
  @Input() tipo: string;

  constructor() { }

  ngOnInit(): void {
  }

}
